var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20H11.6667V18.3333C11.6667 16.955 12.7883 15.8333 14.1667 15.8333H17.5C18.8783 15.8333 20 16.955 20 18.3333V20ZM15.8333 15C14.6842 15 13.75 14.0658 13.75 12.9167C13.75 11.7675 14.6842 10.8333 15.8333 10.8333C16.9825 10.8333 17.9167 11.7675 17.9167 12.9167C17.9167 14.0658 16.9825 15 15.8333 15ZM10 18.3333C10 16.6425 11.0167 15.19 12.4667 14.5375C12.2283 14.045 12.0833 13.4992 12.0833 12.9167C12.0833 11.8125 12.5717 10.8292 13.3333 10.1417V2.5C13.3333 1.12167 12.2117 0 10.8333 0H2.5C1.12167 0 0 1.12167 0 2.5V20H10V18.3333ZM10 12.5H7.5V10.8333H10V12.5ZM5.83333 15.8333H3.33333V14.1667H5.83333V15.8333ZM5.83333 12.5H3.33333V10.8333H5.83333V12.5ZM4.16667 6.66667V5H5.83333V3.33333H7.5V5H9.16667V6.66667H7.5V8.33333H5.83333V6.66667H4.16667ZM7.5 14.1667H10V15.8333H7.5V14.1667Z",
    fill: "url(#paint0_linear_192_497)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_497",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.c5d4d2fb1c1e17657d56293b3a6384cf.svg";
export { ForwardRef as ReactComponent };